export default "__VITE_ASSET__CHgkGsQX__"